export const vendorModel = ({
    vendorId,
    name,
    email,
    contactName,
    phoneNumber,
    faxNumber,
    address,
    city,
    state,
    zipCode,
    website,
    systemType,
}: Record<string, any> = {}) => ({
    vendorId,
    name,
    email,
    contactName,
    phoneNumber,
    faxNumber,
    address,
    city,
    state,
    zipCode,
    website,
    systemType,
});

export const emptyVendorModel = vendorModel();
